import Button from "@/components/bricks/button/Button";
import {
  TicketHeading,
  TicketRoot,
  TicketSub,
  TicketSubItem,
} from "../../../ticket/Ticket";
import { useNavigate } from "react-router-dom";
import { FirmaByPnrResponse } from "../opretFirmaInterface";
import { AlertMessage } from "../../../AlertMessage";

export default function DuplicateFirmaWarning(props: {
  existingFirma: FirmaByPnrResponse;
  onCancel: () => void;
  reason: "p-nummer" | "navn";
}) {
  const { existingFirma, onCancel, reason } = props;
  const { cvrNr, id, navn1, pnr } = existingFirma;

  const navigate = useNavigate();
  return (
    <AlertMessage
      warningIcon
      type="warning"
      heading={`Firmaet er allerede oprettet med samme ${reason}`}
    >
      <div>
        <TicketRoot
          key={id}
          icon="arrow"
          className="bg-white shadow"
          onClick={(e: any) => {
            if (e.metaKey || e.ctrlKey) {
              window.open(`/firma/${id}`, "_blank");
            } else {
              navigate(`/firma/${id}`, { replace: false });
            }
          }}
        >
          <TicketHeading>
            <h4 className="h5">{navn1}</h4>
          </TicketHeading>
          <TicketSub>
            <TicketSubItem>CVR: {cvrNr}</TicketSubItem>
            <TicketSubItem> | </TicketSubItem>
            <TicketSubItem>Pnr: {pnr}</TicketSubItem>
          </TicketSub>
        </TicketRoot>
      </div>
      <div className="d-flex gap-2 flex-row justify-content-between mt-3">
        <Button color="warning" onClick={onCancel}>
          Annuller
        </Button>
      </div>
    </AlertMessage>
  );
}
